import { Box, Grid } from "@mui/material";
import { useTeamPageLayoutContext } from "..";
import { useBreakpoints, useSettings } from "../../../hooks";
import { TeamAbout, TeamFeed, TeamNetwork } from "./components";
import { TeamOverviewSection } from "src/constants";

const TeamOverviewPage = () => {
  const { isMdUp, isLgUp } = useBreakpoints();
  const { team } = useTeamPageLayoutContext();
  const { teamSettings } = useSettings();

  return (
    <Box sx={{ width: "100%", justifyContent: "center", display: "flex" }}>
      <Grid
        container
        spacing={{ xs: 0.75, md: 1 }}
        sx={{
          width: teamSettings.expandedSection !== undefined && isLgUp ? "66.67%" : "100%",
        }}
      >
        {!isMdUp ? (
          <>
            <Grid size={12}>
              <TeamAbout />
            </Grid>
            <Grid size={12}>
              <TeamFeed />
            </Grid>
            <Grid size={12}>
              <TeamNetwork teamSlug={team.slug} />
            </Grid>
          </>
        ) : (
          <>
            <Grid
              size={{ md: teamSettings.expandedSection !== undefined ? 12 : 4 }}
              sx={{
                maxHeight: teamSettings.expandedSection !== undefined ? "720px" : "unset",
              }}
            >
              {teamSettings.expandedSection === undefined ||
              teamSettings.expandedSection === TeamOverviewSection.Feed ? (
                <TeamFeed sx={{ height: "100%", display: "flex", flexDirection: "column" }} />
              ) : teamSettings.expandedSection === TeamOverviewSection.About ? (
                <TeamAbout sx={{ height: "100%", display: "flex", flexDirection: "column" }} />
              ) : (
                <TeamNetwork teamSlug={team.slug} sx={{ height: "100%", display: "flex", flexDirection: "column" }} />
              )}
            </Grid>
            <Grid size={{ md: teamSettings.expandedSection !== undefined ? 6 : 4 }}>
              {teamSettings.expandedSection === undefined ||
              teamSettings.expandedSection === TeamOverviewSection.Feed ? (
                <TeamAbout />
              ) : (
                <TeamFeed />
              )}
            </Grid>
            <Grid size={{ md: teamSettings.expandedSection !== undefined ? 6 : 4 }}>
              {teamSettings.expandedSection !== TeamOverviewSection.Network ? (
                <TeamNetwork teamSlug={team.slug} />
              ) : (
                <TeamAbout />
              )}
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export { TeamOverviewPage };
